import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class AuditService {
  baseUrl = 'audit';

  getGrid = (filter) => Utils.grid.getParameters(`${this.baseUrl}/get-grid?${filter}`);
  getTypes = () => BaseService.get({ url: `${this.baseUrl}/get-audit-types` });
}

export default new AuditService()
